import annotator from 'annotator'
import AnnotatorStorage from '@/utils/annotatorStorage'
import i18n from '@/i18n';

const baseUrl = process.env.VUE_APP_BOOKSYNC_URL + '/api' || ''

export default {
  init: function (options) {
    let app = new annotator.App()

    // annotator ui is only available in browsers
    if (annotator.ui) {
      app.include(annotator.ui.main, {
        element: options.element
      })
    }

    app.include(this.fagbokStorageHook, options.element)
    app.include(this.fagbokStoragePlugin, {
      baseUrl: baseUrl,
      accessToken: options.accessToken,
      book: options.bookId,
      page: options.page
    })

    let authorization = {
      permits: function () { return true },
      authorizedUserId: function (u) { return options.user.id }
    }
    app.registry.registerUtility(authorization, 'authorizationPolicy')

    app.start()
      .then(async () => {
        const cache = await app.annotations.store.getFromDB()

        if (cache.length) {
          app.runHook('annotationsLoaded', [cache])
        }
      })
  },

  fagbokStoragePlugin: function (conf) {
    let storage = new AnnotatorStorage(conf)
    return {
      configure: function (registry) {
        registry.registerUtility(storage, 'storage')
      }
    }
  },

  fagbokStorageHook: function (elementHook) {
    const _annotationStyleClass = function (ann) {
      return ann.text.length > 0 ? 'annotator-note' : 'annotator-hl'
    }

    const _removeHighlight = function (event, element) {
      if(event) {
        event.preventDefault()
      }

      setTimeout(function () {
        const editor = document.querySelectorAll('.annotator-outer.annotator-viewer:not(.annotator-hide)')[[element.id === 'page_1' ? 0 : 1]]
        editor.classList.add('annotator-hide')
        editor.querySelector('.annotator-delete').click()
      }, 100)
    }

    const _addClickEvents = function (ann, element) {
      let annotationStyleClass = _annotationStyleClass(ann)

      ann._local.highlights.forEach(function (el) {
        el.classList.add(annotationStyleClass)
        // Highlight remove by click
        if (annotationStyleClass !== 'annotator-note') {
          el.removeEventListener('click', event => {_removeHighlight(event, element)})
          el.addEventListener('click', event => {_removeHighlight(event, element)})
        } else {
          el.addEventListener('click', event => {_noteEditorOpen(event, element)})
          el.addEventListener('click', event => {_setEditorHeadingText(event, element)})
        }
      })
    }

    const _setEditorHeadingText = (event, element) => {
      setTimeout(() => {
        document.querySelectorAll(`.annotator-editor`)[element.id === 'page_1' ? 0 : 1].querySelector('.c-annotator__heading-text').innerHTML = i18n.t('EDIT_NOTE')
      }, 50)
    }

    const _noteEditorOpen = (event, element) => {
      setTimeout(() => {
        const editor = document.querySelectorAll(`.annotator-viewer`)[element.id === 'page_1' ? 0 : 1]
        const noteEditorBtn = editor.querySelector('.annotator-edit')
        const noteEditor = document.querySelectorAll(`.annotator-editor`)[element.id === 'page_1' ? 0 : 1]
        noteEditorBtn.click()
        noteEditorBtn.style.display = 'block'
        noteEditor.querySelector('.annotator-delete').classList.remove('hide')
        noteEditor.querySelector('.annotator-delete').addEventListener('click', e => {
          if (!e) return
          e.preventDefault()
          editor.querySelector('.annotator-delete').click()
          noteEditor.classList.add('annotator-hide')
        })
      }, 50)
    }

    return {
      start: function (app) {
      },
      annotationsLoaded: function (ann) {
        ann.forEach(function (an) {
          _addClickEvents(an, elementHook)
        })
      },
      annotationCreated: function (ann) {
        _addClickEvents(ann, elementHook)
      },
      beforeAnnotationCreated: function (ann) {
      },
      annotationUpdated: function (ann) {
        _addClickEvents(ann, elementHook)
      },
      beforeAnnotationUpdated: function (ann) {
      },
      annotationDeleted: function (ann) {
      },
      beforeAnnotationDeleted: function (ann) {
      }
    }
  }
}
